import { IJourneySchema } from "../../../../types/journeyInput.types";

export const annualReviewJourney: IJourneySchema = {
  journeyId: "annual-review",
  journeyName: "Annual Review",
  description:
    "Complete your annual review so your adviser can check your current circumstances, income needs, attitude to risk, and retirement objectives. This helps confirm whether your plan remains suitable and whether any changes should be recommended.",
  tagLine: "Keep your plan aligned with your circumstances",
  available: true,
  basePriority: 1000, // always outranks other journeys while qualified (see qualificationRules below)
  qualificationRules: {
    all: [
      {
        // Qualifies only while "started" (100299) is the most recent of the three —
        // i.e. later than both "complete" (100019) and "cancelled" (100300).
        fact: "latestMilestoneId",
        params: { ids: ["100299", "100019", "100300"] },
        operator: "equal",
        value: "100299",
      },
    ],
  },
  tools: [
    {
      toolId: "annual-review-details",
      completionOrder: 1,
      isRequired: true,
    },
    {
      toolId: "annual-review-booking",
      completionOrder: 2,
      isRequired: true,
    },
    {
      toolId: "annual-review",
      completionOrder: 3,
      isRequired: true,
    },
  ],
};
